module.exports = __webpack_public_path__ + "static/usopen-02-91df1f9a9ffc426417cf9559c7778a01.jpg";